
export class StringHelper {
  public static isString(value: any): boolean {
    return Object.prototype.toString.call(value) === '[object String]';
  }

  public static stringToEnum<T extends { [key: string]: string }>(enumObj: T, str: string): T[keyof T] | undefined {
    const enumValues = Object.values(enumObj) as string[];
    return enumValues.includes(str) ? (str as T[keyof T]) : undefined;
  }

  public randomCode(length: number): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++)
      result += characters.charAt(Math.floor(Math.random() * charactersLength));

    return result;
  }
}
